import { useEffect } from 'react'

export const useScrollToTop = (dependencies: any[] = []) => {
  useEffect(() => {
    const layout = document.getElementById('mainLayout')
    layout?.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
}
